import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable()
export class NavigationService {
  constructor(private router: Router) {}

  public goToLoginPage(options?: { next?: string }): void {
    const nextUrl = (options && options.next) || location.href;
    const loginUrl = `/saml/login?next=${encodeURIComponent(nextUrl)}`;
    location.href = loginUrl;
  }

  public goToDashboard(): void {
    this.router.navigate(["/"]);
  }

  public goToUrl(url: string, options?: { refresh?: boolean }): void {
    if (isAbsoluteUrl(url) || (options && options.refresh)) {
      location.href = url;
    } else {
      this.router.navigateByUrl(url);
    }
  }
}

function isAbsoluteUrl(url: string): boolean {
  return /^https?:\/\//i.test(url);
}



// WEBPACK FOOTER //
// ./src/app/common/services/navigation/navigation.service.ts